import { Alert, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { Permission } from '@/shared/auth/permissions'
import { ExpandableHint } from './ExpandableHint'

interface PermissionNoticeProps {
  /**
   * Yetishmayotgan huquq KODI — ekranga AYNAN shu satr chiqadi.
   *
   * ⚠️ Tarjima qilinmaydi va chiroyli nomga almashtirilmaydi: operator
   * uni rol konstruktorida (`/roles`) aynan shu nom bilan qidiradi.
   */
  permission: Permission
  /** Nega bu blok yopiq va nima yo'qoladi — bir-ikki jumla */
  reason: string
  /** Blok sarlavhasi (masalan «Ish haqi») — nima yopilganini aytadi */
  title?: string
}

/**
 * Huquq yetmagan BO'LIM o'rniga chiziladigan izoh.
 *
 * <h2>⚠️ NEGA 403 BANNERI EMAS</h2>
 * `RequirePermission` butun SAHIFANI yopadi va u yerda «Ruxsat yo'q»
 * to'g'ri javob. Bu yerda esa sahifa ochiq, faqat bitta BLOK yopiq —
 * va quruq «Ruxsat yo'q» uch savolni javobsiz qoldirardi:
 * nima yopilgan, nega, va buni ochish uchun nima so'rash kerak.
 *
 * Shuning uchun uchalasi ham yoziladi va uchinchisi — HUQUQ KODI —
 * ekranda XOM ko'rinadi. Administrator rol konstruktorida uni aynan
 * shu nom bilan topadi; «maosh huquqi» degan tarjima esa u yerda
 * hech narsani topmasdi.
 *
 * <h2>⚠️ BU BLOK MA'LUMOT SIZDIRMAYDI</h2>
 * U faqat huquq nomini aytadi — qiymatni emas. Chaqiruvchi esa
 * so'rovni UMUMAN yubormaydi (`enabled: can(...)`): 403 javobining
 * o'zi ham «bu odamda maosh yozuvi bor» degan faktni tasdiqlardi va
 * u tarmoq jurnalida qolardi.
 *
 * <h2>⚠️ SABAB «BATAFSIL» OSTIDA</h2>
 * Matn ikki qatordan uzun bo'lsa `ExpandableHint` uni yig'adi
 * (XSB-004): izoh formani bosib ketmasin, lekin FAKT ham
 * yo'qolmasin (§23.2, 6-qoida).
 */
export function PermissionNotice({ permission, reason, title }: PermissionNoticeProps) {
  const { t } = useTranslation()

  return (
    <Alert
      type="info"
      showIcon
      message={title ?? t('access.blockHiddenTitle')}
      description={
        <>
          <ExpandableHint text={reason} fontSize={14} />
          <div style={{ marginTop: 8 }}>
            <Typography.Text type="secondary">{t('access.needPermission')} </Typography.Text>
            <Typography.Text code copyable={{ text: permission }}>
              {permission}
            </Typography.Text>
          </div>
        </>
      }
    />
  )
}
